import React, { Component } from 'react';
import { connect } from 'react-redux';

import { hideModal } from 'actions/modalActions';
import Button from 'components/Button';

class Dismiss extends Component {
	render() {
		const { hideModal, children, ...props } = this.props;

		return (
			<Button {...props} onClick={hideModal}>
				{children}
			</Button>
		);
	}
}

const mapDispatchToProps = { hideModal };

export default connect(null, mapDispatchToProps)(Dismiss);
